/** @format */

import $ from "jquery";
import axios from "axios";
import { Input } from "antd";
import React, { useEffect, useState } from "react";
import { SearchOutlined } from "@ant-design/icons";

import { NavLink } from "react-router-dom";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import print from "../../../../icons/print.png";
import { header } from "../../../../components/api/Header";
import { monthName } from "../../../../components/functions/Month";
import LoadingCard from "../../../../components/loading/loadingCard";
import { ExcelPrint, PrintElem } from "../../../../components/functions/Print";
import { getEnv } from "../../../../lib/env";

function getPreviousDate(value) {
  if (!value) return "";
  const [year, month, day] = value.split("-").map(Number);
  const current = new Date(year, month - 1, day);
  current.setDate(current.getDate() - 1);

  return [
    current.getFullYear(),
    String(current.getMonth() + 1).padStart(2, "0"),
    String(current.getDate()).padStart(2, "0"),
  ].join("-");
}

function getDateLabel(value) {
  if (!value) return "";
  return `${parseInt(value.slice(8, 10), 10)} ${monthName(value).toLowerCase()}`;
}

function Table3({ date, setOmbor }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const selectedDateLabel = getDateLabel(date);
  const previousDateLabel = getDateLabel(getPreviousDate(date));

  const setSearch = (text) => {
    $("tbody tr.data-tr").each(function () {
      if (
        $(this)
          .children(".fix-with")[0]
          .innerText.toUpperCase()
          .indexOf(text.toUpperCase()) > -1
      ) {
        $(this)[0].style.display = "";
      } else {
        $(this)[0].style.display = "none";
      }
      if (text != "") {
        $("tbody tr.j-tr").css("display", "none");
      } else {
        $("tbody tr.j-tr").css("display", "");
      }
    });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/suvombor/table3?date=" +
            date,
          header()
        );
        setData(res.data);
      } catch (e) {
        console.log("Xato", e);
        alert("Bazaga bog'lanishda xato");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [date]);

  return (
    <>
      <div className='table-content-top'>
        <div className='table-top-left'>
          <Input
            prefix={<SearchOutlined className='site-form-item-icon' />}
            placeholder='Search'
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <ul className='table-top-right'>
          <li>
            <button className='btn p-0' onClick={() => PrintElem(".table")}>
              <img src={print} alt='404' />
            </button>
          </li>

          <li>
            <NavLink
              style={{
                color: "#25213b",
              }}
              to={
                `${getEnv('REACT_APP_BASE_URL')}/export/mpdf?sana=` +
                date +
                "&table=suvombor2"
              }
              className='btn p-0'>
              <img src={pdf} alt='404' />
            </NavLink>
          </li>

          <li>
            <button
              className='btn p-0'
              onClick={() => ExcelPrint("Suv omborlari jadval3", date, "so3")}>
              <img src={excel} alt='404' />
            </button>
          </li>
        </ul>
      </div>

      <div className='table-responsive tableFixHead' id='tableFlexible'>
        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <table className='table table-bordered table-style' id='so3'>
            <thead>
              <tr>
                <th rowSpan={3} scope='col'>
                  N
                </th>

                <th rowSpan={3} scope='col'>
                  Suv Omborlar nomi
                </th>

                <th colSpan={4} scope='col'>
                  Hajmi (mln.m3)
                </th>

                <th colSpan={3} scope='col'>
                  Kelishi, m3/sek
                </th>

                <th colSpan={3} scope='col'>
                  Chiqishi, m3/sek
                </th>

                <th rowSpan={2} scope='col'>
                  Kelishi-Chiqishi
                </th>

                <th rowSpan={2} scope='col'>
                  Yo'qolishi
                </th>
              </tr>

              <tr>
                <th rowSpan={2} scope='col'>
                  Loyiha bo’yicha
                </th>

                <th colSpan={2} scope='col'>
                  Amalda
                </th>

                <th rowSpan={2} scope='col'>
                  Farqi +-
                </th>

                <th colSpan={2} scope='col'>
                  Amalda
                </th>

                <th rowSpan={2} scope='col'>
                  Farqi +-
                </th>

                <th colSpan={2} scope='col'>
                  Amalda
                </th>

                <th rowSpan={2} scope='col'>
                  Farqi +-
                </th>
              </tr>

              <tr>
                <th scope='col'>{previousDateLabel}</th>

                <th scope='col'>{selectedDateLabel}</th>

                <th scope='col'>{previousDateLabel}</th>

                <th scope='col'>{selectedDateLabel}</th>

                <th scope='col'>{previousDateLabel}</th>

                <th scope='col'>{selectedDateLabel}</th>

                <th colSpan={2} scope='col'>
                  mln.m<sup>3</sup>
                </th>
              </tr>
            </thead>

            <tbody></tbody>

            {data.length > 0
              ? data.map((d, index) => {
                  return (
                    <tbody key={index}>
                      {index === 26 ? (
                        <tr className='j-tr'>
                          <td></td>
                          <td>shu jumladan</td>
                        </tr>
                      ) : null}
                      <tr className='data-tr'>
                        <td>{index + 1}</td>

                        <td className='text-start fix-with'>
                          <NavLink
                            style={{
                              color: "#25213b",
                              textDecoration: "none",
                            }}
                            to={"/suvomborlari/" + d.id}
                            onClick={() =>
                              setOmbor({
                                nomi: d.nomi,
                                location: [d.lat, d.lan],
                              })
                            }>
                            {d.nomi}
                          </NavLink>
                        </td>

                        <td>{d.loyiha_boyicha}</td>

                        <td>{d.data1}</td>

                        <td>{d.data2}</td>

                        <td>{farq(d.data2, d.data1)}</td>

                        <td>{d.data3}</td>

                        <td>{d.data4}</td>

                        <td>{farq(d.data4, d.data3)}</td>

                        <td>{d.data5}</td>

                        <td>{d.data6}</td>

                        <td>{farq(d.data6, d.data5)}</td>

                        <td>{farq(d.data4, d.data6, true)}</td>

                        <td>
                          {farq(
                            farq(d.data2, d.data1),
                            farq(d.data4, d.data6, true)
                          )}
                        </td>
                      </tr>
                    </tbody>
                  );
                })
              : null}
          </table>
        )}
      </div>
    </>
  );
}

export default Table3;

const check = (v) => {
  if (!v || v === "undefined" || v === null) {
    return 0;
  } else {
    return v;
  }
};

const farq = (a = 0, b = 0, kop = false) => {
  let s = check(a) - check(b);
  if (kop) {
    s = s * 0.0864;
  }
  if (s % 1 !== 0) {
    return s.toFixed(2);
  } else {
    return s;
  }
};
